import type { HistoryEventItemDto } from '../../services/eventHistoryService';

export type HistoryGrouping = 'month' | 'year';

export interface HistoryEventGroup {
    /** 'YYYY-MM' or 'YYYY' — used for keying, sort order and the heading's testid */
    key: string;
    /** e.g. 'Mai 2026' / 'May 2026', or '2026' */
    label: string;
    events: HistoryEventItemDto[];
}

function groupKey(occurredAt: string, grouping: HistoryGrouping): string {
    const date = new Date(occurredAt);
    const year = String(date.getFullYear());
    return grouping === 'year' ? year : `${year}-${String(date.getMonth() + 1).padStart(2, '0')}`;
}

function groupLabel(key: string, grouping: HistoryGrouping, locale: string): string {
    if (grouping === 'year') return key;
    const [year, month] = key.split('-');
    const raw = new Intl.DateTimeFormat(locale, { month: 'long', year: 'numeric' }).format(new Date(Number(year), Number(month) - 1, 1));
    return raw.charAt(0).toUpperCase() + raw.slice(1);
}

export function groupHistoryEvents(events: HistoryEventItemDto[], grouping: HistoryGrouping, locale: string): HistoryEventGroup[] {
    const map = new Map<string, HistoryEventItemDto[]>();
    for (const event of events) {
        const key = groupKey(event.occurredAt, grouping);
        const bucket = map.get(key);
        if (bucket) bucket.push(event);
        else map.set(key, [event]);
    }
    return Array.from(map.entries())
        .sort(([a], [b]) => b.localeCompare(a))
        .map(([key, items]) => ({ key, label: groupLabel(key, grouping, locale), events: items }));
}
